import React, { useContext } from 'react';
import SidebarItem from './components/SidebarItem';
import { IWordingsContext, WordingsContext } from '../../../wordingsState/wordingsContext';
import style from './Sidebar.module.scss';

const Sidebar: React.FC = () => {
	const { setGroup, groups, selectedGroup } = useContext<IWordingsContext>(WordingsContext);

	return (
		<>
			{groups.length ? (
				<div className={style.container} data-test="Sidebar">
					{groups.map((el) => (
						<SidebarItem
							key={el.id}
							label={el.name || ''}
							isActive={selectedGroup?.id === el.id}
							onClick={() => setGroup(el)}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default Sidebar;
